import { Multicast } from '../multicast/Multicast';
export function getSource(stream) {
    return stream.source instanceof Multicast
        ? stream.source.source
        : stream.source;
}
//# sourceMappingURL=getSource.js.map